import { Link } from '@framework/router/Next/Link';
import { getIssuerRoute } from '@/creditflowresearch/Router/RouteWithRedirect/getNewRoute';
import IssuersCell from '@/creditflowresearch/ui/components/deals/DealListTable/cells/IssuersCellLegacy';
import { collectValidIssuers } from '@/creditflowresearch/ui/components/deals/DealListTable/cells/IssuersCellLegacy/helpers';
import useResponsive, { QUERIES } from '@creditflowresearch/uilib/hooks/useResponsive';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Issuers/issuers.module.scss';

export const Issuers = ({ row }: { row: IDealCellData }) => {
  const issuers = collectValidIssuers(row);

  const isMobile = useResponsive(QUERIES.MOBILE);

  if (!isMobile) {
    // @ts-ignore
    return <IssuersCell row={ row } maxWidth={ 500 } />;
  }

  return (
    <div className={ styles.issuersContainer }>
      { issuers.map((issuer, index) => (
        <span key={ issuer.id } className={ styles.issuerLink }>
          <Link to={ getIssuerRoute(issuer) } className={ styles.link }>{ issuer.name }</Link>
          { index < issuers.length - 1 && <>,&nbsp;</> }
        </span>
      )) }
    </div>
  );
};
